export * from '../types';
export const electronAPI = window.electronApi;
